import { createFileRoute } from "@tanstack/react-router";
import Redirection from "@/features/tradein/pages/redirection/Redirection";

export const Route = createFileRoute("/$locale/$partner/_transitions/redirection")({
	component: Redirection,
});
